import {
  faHandshakeSimple,
  faUsersViewfinder,
  // faBuildingUser,
  faSitemap,
  faUsers,
  faUsersGear,
  faFileCsv,
  faCampground,
  faFile,
  faManatSign,
  faCodePullRequest,
  faDiagramNext,
  faHeartMusicCameraBolt,
  faStamp,
  faUserPlus,
  faHandHoldingHeart,
  faMoneyCheckDollar,
  faCogs
} from '@fortawesome/free-solid-svg-icons';

export const menuItems = [
  {
    title: 'Manage Products',
    icon: faSitemap,
    link: '/home/manage-products',
    parentLink: '/home/manage-products',
    role: ['admin', 'super-admin', 'ops-admin', 'pps-checker', 'pps-onboarding']
  },
  {
    title: 'Pre Eligibility Leads',
    icon: faUserPlus,
    link: '/home/pre-eligibility',
    parentLink: '/home/pre-eligibility',
    role: ['super-admin', 'admin', 'cad']
  },
  {
    title: 'Product Partner Setup',
    icon: faHandshakeSimple,
    link: '/home/product-partner-setup',
    role: ['admin', 'super-admin', 'business-pm', 'ops-admin', 'pps-onboarding']
  },
  {
    title: 'Partner',
    icon: faUsersViewfinder,
    subOptions: [
      {
        label: 'Partner Management',
        subLink: '/home/partner-management',
        role: [
          'admin',
          'super-admin',
          'business-pm',
          'ops-admin',
          'pps-onboarding',
          'ops-support',
          'pps-checker',
          'audit'
        ]
      },
      {
        label: 'CBBO',
        subLink: '/home/cbbo',
        role: [
          'admin',
          'super-admin',
          'ops-support',
          'pps-checker',
          'ops-admin',
          'pps-onboarding',
          'business-pm',
          'audit'
        ]
      }
    ],
    role: [
      'admin',
      'super-admin',
      'business-pm',
      'ops-admin',
      'pps-onboarding',
      'ops-support',
      'pps-checker',
      'audit'
    ]
  },
  {
    title: 'BRE',
    icon: faCogs,
    subOptions: [
      {
        label: 'BRE Executions',
        subLink: '/home/bre-executions',
        role: ['super-admin', 'bre-admin']
      },
      {
        label: 'Rule Master List',
        subLink: '/home/ruleMasterListView',
        role: ['super-admin', 'bre-admin']
      },
      {
        label: 'Request Param Master List',
        subLink: '/home/requestParamMasterListView',
        role: ['super-admin', 'bre-admin']
      }
    ],
    role: ['super-admin', 'bre-admin']
  },
  {
    title: 'Partner Recommendation',
    icon: faCampground,
    link: '/home/partner-recommendation',
    role: ['super-admin', 'partner', 'ops-admin']
  },
  {
    title: 'Requests',
    icon: faCodePullRequest,
    link: '/home/requests',
    role: [
      'admin',
      'cad',
      'super-admin',
      'partner',
      'business-pm',
      'unnati-kyc-user',
      'rm',
      'ops-admin',
      'ops-support'
    ]
  },
  {
    title: 'Document Management',
    icon: faFile,
    subOptions: [
      {
        label: 'Legality Document Management',
        subLink: '/home/legality-management/dashboard',
        role: ['document-editor', 'cad', 'audit']
      },
      {
        label: 'SignDesk Document Management',
        subLink: '/home/signDesk',
        role: ['document-editor', 'cad', 'audit']
      },
      {
        label: 'Standby Line - Post-Flip (SAMAGRO)',
        subLink: '/home/legality-management/post-flip',
        role: ['document-editor', 'cad']
      },
      {
        label: 'SFPL - After-Flip Drafts',
        subLink: '/home/legality-management/after-flip',
        role: ['document-editor', 'cad']
      },
      {
        label: 'SAVCPL- BTST ',
        subLink: '/home/legality-management/btst',
        role: ['document-editor', 'cad']
      },
      {
        label: 'Miscellaneous Assets',
        subLink: '/home/legality-management/miscellaneous-assets',
        role: ['document-editor']
      },
      {
        label: 'NDC',
        subLink: '/home/no-due-certificate',
        role: ['document-editor', 'cad']
      },
      {
        label: 'Intimation Letter',
        subLink: '/home/intimation-letter',
        role: ['document-editor', 'cad']
      },
      {
        label: 'Credit PD Report',
        subLink: '/home/credit-pd-report',
        role: ['document-editor', 'cad']
      }
    ],
    role: ['document-editor', 'cad', 'audit']
  },
  {
    title: 'CAD Management',
    icon: faManatSign,
    subOptions: [
      {
        label: 'Cad360 Dashbord',
        subLink: '/home/cad-dashboard',
        role: [
          'super-admin',
          'admin',
          'cad',
          'unnati-kyc-user',
          'audit',
          'cbo',
          'nch'
        ]
      },
      {
        label: 'CAD Management',
        subLink: '/home/cad-management',
        role: [
          'super-admin',
          'admin',
          'cad',
          'unnati-kyc-user',
          'audit',
          'cbo',
          'nch'
        ]
      }
    ],
    role: [
      'super-admin',
      'admin',
      'cad',
      'unnati-kyc-user',
      'audit',
      'cbo',
      'nch'
    ]
  },
  {
    title: 'User Management',
    icon: faUsers,
    link: '/home/user-management',
    role: [
      'admin',
      'super-admin',
      'business-pm',
      'ops-admin',
      'pps-onboarding',
      'ops-support',
      'techie'
    ]
  },
  {
    title: 'Reports',
    icon: faFileCsv,
    link: '/home/reports',
    role: [
      'admin',
      'cad',
      'super-admin',
      'partner',
      'business-pm',
      'rm',
      'ops-admin',
      'ops-support',
      'audit'
    ]
  },
  {
    title: 'View Rule Master',
    icon: faUsersGear,
    link: '/home/manage-bre',
    role: ['admin', 'super-admin']
  },
  {
    title: 'HealthCheck',
    icon: faHeartMusicCameraBolt,
    link: '/home/health-check',
    role: ['super-admin', 'admin']
  },
  {
    title: 'Multiple Digital Stamp Form',
    icon: faStamp,
    link: '/home/multiple-digital-stamp',
    parentLink: '/home/multiple-digital-stamp',
    role: ['admin', 'super-admin', 'document-editor', 'cad']
  },
  {
    title: 'Insurance Dashbord',
    icon: faHandHoldingHeart,
    link: '/home/insurance-dashboard',
    role: ['super-admin', 'business-ops']
  },
  {
    title: 'Insights',
    icon: faDiagramNext,
    link: '/home/insight',
    role: ['partner', 'bi-insights']
  },
  {
    title: 'Disbursement Batch List',
    icon: faMoneyCheckDollar,
    link: '/home/batch-disbursement-list',
    role: ['super-admin', 'business-ops', 'credit-ops']
  },
  {
    title: 'Tools',
    icon: faUsersViewfinder,
    subOptions: [
      {
        label: 'UserLogs',
        subLink: '/home/userLogs',
        role: ['super-admin']
      },
      {
        label: 'Pincode',
        subLink: '/home/tools',
        role: ['super-admin']
      },
      {
        label: 'Product Repayment Mode',
        subLink: '/home/productRepaymentModeMapping',
        role: ['super-admin']
      },
      {
        label: 'Field Master Setup View',
        subLink: '/home/fieldMasterSetupView',
        role: ['super-admin']
      }
    ],
    role: ['super-admin']
  }
];

export const customerHomePageItems = [
  { label: 'Active customers', icon: 'filter' },
  { label: 'In-active customers', icon: 'filter' },
  { label: 'All customers', icon: 'filter' }
];

// * TABLE HEADER VALUES

export const customerHomePageHeaders = [
  { label: 'Customer Id', isSortable: true },
  { label: 'Name' },
  { label: 'Contact no' },
  { label: 'Email' },
  { label: 'Address' },
  { label: 'Reg. date' },
  { label: 'Last order date' },
  { label: 'Status' },
  { label: 'Action' }
];

export const workshopsHomePageHeaders = [
  { label: '' },
  { label: 'Workshop name', isSortable: true },
  { label: 'Workshop date', isSortable: true },
  { label: 'Workshop time', isSortable: true },
  { label: 'Platform', isSortable: true },
  { label: 'Workshop fee', isSortable: true },
  { label: 'Revenue generated', isSortable: true },
  { label: 'Conductor name' },
  { label: 'Status' },
  { label: 'Actions' }
];

// * BREADCRUMBS DATAS

export const workshopEarningsBreadcrumbs = [
  {
    label: 'WORKSHOPS',
    link: '/workshops'
  },
  {
    label: 'workshop earning details',
    link: '/workshops/earnings-details',
    isActive: null
  }
];

export const addManageProductsBreadcrumbs = [
  {
    label: 'Manage Products',
    link: '/home/manage-products',
    isActive: true
  },
  {
    label: 'Add',
    link: '/home/manage-products',
    isActive: null
  }
];

export const viewManageProductsBreadcrumbs = [
  {
    label: 'Manage Products',
    link: '/home/manage-products',
    isActive: true
  },
  {
    label: 'Update',
    link: '/home/manage-products',
    isActive: null
  }
];

export const editManageProductsBreadcrumbs = [
  {
    label: 'Manage Products',
    link: '/home/manage-products',
    isActive: true
  },
  {
    label: 'Edit',
    link: '/home/manage-products',
    isActive: null
  }
];

export const addWorkshopBreadcrumbs = [
  {
    label: 'WORKSHOPS',
    link: '/workshops'
  },
  {
    label: 'Add Workshop',
    link: '/workshops',
    isActive: null
  }
];

export const viewModifyRulesBreadcrumbs = [
  {
    label: 'Manage Products',
    link: '/home/manage-products',
    isActive: true
  },
  {
    label: 'View',
    link: '/home/manage-products/view',
    isActive: true
  },
  {
    label: 'Attach Rules',
    link: '/home/manage-products/modifyRules',
    isActive: null
  }
];

export const editModifyRulesBreadcrumbs = [
  {
    label: 'Manage Products',
    link: '/home/manage-products',
    isActive: true
  },
  {
    label: 'Edit',
    link: '/home/manage-products/edit',
    isActive: true
  },
  {
    label: 'Attach Rules',
    link: '/home/manage-products/modifyRules',
    isActive: null
  }
];

export const ModifyRulesBreadcrumbs = [
  {
    label: 'Manage Products',
    link: '/home/manage-products',
    isActive: true
  },
  {
    label: 'Product Partner Setup',
    link: '/home/product-partner-setup',
    isActive: true
  },
  {
    label: 'Attach Rules',
    link: '/home/manage-products/modifyRules',
    isActive: null
  }
];

export const supplierBreadcrumbs = [
  {
    label: 'Product Partner Setup',
    link: '/home/product-partner-setup',
    productPartner: true
  },
  {
    label: 'Product Partner Setup Id',
    link: '/home/product-partner-setup',
    productPartnerSetup: true,
    partnerName: ''
  },
  {
    label: 'Suppliers',
    link: '/home/product-partner-setup/add-suppliers',
    isActive: null,
    labelName: 'mapSupplier'
  }
];

export const modifyBranchesBreadcrumbs = [
  {
    label: 'Product Partner Setup',
    link: '/home/partner-management'
  },
  {
    label: 'Partner Management',
    link: '/home/partner-management',
    isActive: true
  },
  {
    label: '',
    link: '/home/partner-management',
    isActive: true,
    partnerName: true
  },
  {
    label: 'Branches',
    link: '/home/partner-management',
    isActive: null
  }
];
